// Module
var code = "<div class=\"content-pad organization-dashboard ensure-viewport-height grey-bg\"> <dashboard></dashboard> </div> ";
// Exports
export default code;